(ns machtfit.product-form.when
  (:require [cljs-time.core
             :refer
             [day days hour local-date-time minute minutes month weeks year]]
            [cljs.core.match :refer [match]]
            [clojure.string :as str]
            [machtfit.core :as machtfit]
            [machtfit.dashboard-widgets :as widgets]
            [machtfit.datetime :as datetime]
            [machtfit.human :as human]
            [machtfit.product-form.core :as product-form]
            [machtfit.product-form.handlers :as-alias handlers]
            [machtfit.product-form.review :as review]
            [machtfit.product-form.section
             :refer
             [reset-last-focused-config-section show-next-section]
             :as section]
            [machtfit.utils :refer [save-scroll-position scroll-down]]
            [re-frame.core :as rf]))

(defn- set-offer-list-deadline [db deadline]
  (assoc-in db [:product :when :offer-list-deadline] deadline))

(rf/reg-event-db ::set-offer-list-deadline
  (fn [db [_ deadline]]
    (set-offer-list-deadline db deadline)))

(defn- offer-list-deadline []
  [:div.col.s12
   [:div.valign-wrapper
    [:span "Das Angebot wird angezeigt, bis einschließlich "
     [widgets/inline-date-input
      {:read-only? false
       :required? false
       :value @(rf/subscribe [:get [:product :when :offer-list-deadline]])
       :on-save #(rf/dispatch [::set-offer-list-deadline %])}]]]
   [:div {:style {:font-size "0.8rem" :cursor "default" :color "#9e9e9e" :margin "0.5rem 0 1rem"}}
    "Ändern Sie das Datum, wenn das Angebot auch nach der Anmeldefrist noch angezeigt werden soll."]])

(rf/reg-event-db ::reset-schedule
  (fn [db _]
    (-> db
        (update-in [:product :when :schedules] (fn [schedule]
                                                 (mapv
                                                  #(assoc % :deleted? true)
                                                  schedule)))
        (update-in [:product :when :slots] (fn [slot]
                                             (mapv
                                              #(select-keys % [:group])
                                              slot)))
        (assoc-in [:product :when :weekdays] {})
        (assoc-in [:product :when :unit-duration] nil))))

(rf/reg-event-fx ::set-has-schedule
  (fn [{:keys [db]} [_ new-has-schedule]]
    {:db (-> db
             (assoc-in [:product :when :has-schedule?] new-has-schedule)
             (assoc-in [:ui :last-focused-config-section] :when))
     :dispatch [::reset-schedule]}))

(defn- has-schedule []
  (let [is-last-section? @(rf/subscribe [::section/is-last-visible-section? :when])]
    [:div.col.s12.valign-wrapper {:style {:margin-bottom "0.5rem"}}
     [widgets/choice
      {:name "has-schedule"
       :intro "Das Angebot "
       :current-choice @(rf/subscribe [:get [:product :when :has-schedule?]])
       :choices [[true "ist terminbasiert."]
                 [false "ist unabhängig von Terminen."]]
       :on-select #(do (rf/dispatch [::set-has-schedule %])
                       (when is-last-section? (scroll-down)))}]]))

(defn- has-schedule-ro []
  [:span "Das Angebot "
   [:b (case @(rf/subscribe [:get [:product :when :has-schedule?]])
         true "ist terminbasiert."
         false "ist unabhängig von Terminen.")]])

(rf/reg-event-fx ::set-sessions-per-signup
  (fn [{:keys [db]} [_ new-sessions-per-signup]]
    {:db (-> db
             (assoc-in [:product :when :sessions-per-signup] new-sessions-per-signup)
             (assoc-in [:ui :last-focused-config-section] :when))
     :dispatch [::reset-schedule]}))

(defn- sessions-per-signup []
  (let [is-last-section? @(rf/subscribe [::section/is-last-visible-section? :when])]
    [:div.col.s12.valign-wrapper {:style {:margin-bottom "0.5rem"}}
     [widgets/choice
      {:name "sessions-per-signup"
       :intro "Eine Anmeldung gilt für"
       :choices [[:one-session "einen Termin."]
                 [:multiple-sessions "mehrere Termine."]]
       :current-choice @(rf/subscribe [:get [:product :when :sessions-per-signup]])
       :on-select #(do (rf/dispatch [::set-sessions-per-signup %])
                       (when is-last-section? (scroll-down)))}]]))

(defn- sessions-per-signup-ro []
  [:span "Eine Anmeldung gilt für "
   [:b (case @(rf/subscribe [:get [:product :when :sessions-per-signup]])
         :one-session "einen Termin."
         :multiple-sessions "mehrere Termine."
         "nil")]])

(rf/reg-event-fx ::set-cohesion
  (fn [{:keys [db]} [_ new-cohesion]]
    (let [path [:product :when :cohesion]]
      {:db (-> db
               (assoc-in path new-cohesion)
               (assoc-in [:ui :last-focused-config-section] :when))
       :dispatch [::reset-schedule]})))

(defn- cohesion []
  (let [is-last-section? @(rf/subscribe [::section/is-last-visible-section? :when])]
    [:div.col.s12.valign-wrapper {:style {:margin-bottom "1rem"}}
     [widgets/choice
      {:name "cohesion"
       :intro "Die Termine"
       :current-choice @(rf/subscribe [:get [:product :when :cohesion]])
       :choices [[:progressive "bauen aufeinander auf (z.B. ein Kurs)."]
                 [:independent "sind unabhängig voneinander; ein Einstieg ist jederzeit möglich (z.B. 10er-Karte)."]]
       :on-select #(do (rf/dispatch [::set-cohesion %])
                       (when is-last-section? (scroll-down)))}]]))

(defn- cohesion-ro []
  [:span "Die Termine "
   [:b
    (case @(rf/subscribe [:get [:product :when :cohesion]])
      :progressive "bauen aufeinander auf."
      :independent "sind unabhängig voneinander.")]])

(rf/reg-event-db ::toggle-weekday-takes-place?
  (fn [db [_ weekday]]
    (-> db
        (update-in [:product :when :weekdays weekday :takes-place?] not)
        (assoc-in [:ui :last-focused-config-section] nil))))

(rf/reg-event-db ::set-weekday-time
  (fn [db [_ weekday index new-time]]
    (-> db
        (update-in [:product :when :weekdays weekday :times]
                   #(-> (or % [nil])
                        (assoc index new-time)))
        (update-in [:product :when :weekdays weekday :times]
                   #(filterv (fn [time]
                               (not (or (nil? time)
                                        (str/blank? time)))) %))
        reset-last-focused-config-section)))

(defn- weekday [key short-name takes-place? word]
  ^{:key (str key "takes-place")}
  [:div
   [:input.filled-in {:type "checkbox"
                      :id (str "weekdays-" short-name)
                      :checked takes-place?
                      :on-change #(rf/dispatch [::toggle-weekday-takes-place? key])}]
   [:label.black-text {:for (str "weekdays-" short-name)
                       :style {:height "auto"
                               :line-height "normal"}}
    word]])

(rf/reg-event-db ::add-time
  (fn [db [_ weekday']]
    (-> db
        (update-in [:product :when :weekdays weekday' :times] #(conj (or %1 []) nil)))))

(defn- weekday-times [key times]
  (let [times* (if (empty? times) [nil] times)
        last-time (last times*)
        last-time-not-blank? (not (or (nil? last-time) (str/blank? last-time)))]
    ^{:key (str key "times")}
    (-> [:div]
        (conj "um ")
        (into (reduce
               into
               (for [[index time] (map-indexed vector times*)]
                 [[widgets/inline-time-input
                   {:value time
                    :on-save #(rf/dispatch [::set-weekday-time key index %])}]
                  ^{:key (str index "t")}
                  (when (< index (dec (count times))) [:span " und um "])])))
        (conj [:span " " (when last-time-not-blank?
                           [:a.waves-effect {:style {:font-size "0.8rem"}
                                             :on-click #(rf/dispatch [::add-time key])}
                            "Zeit hinzufügen"])]))))

(defn- weekdays []
  (let [names {:mon "montags"
               :tue "dienstags"
               :wed "mittwochs"
               :thu "donnerstags"
               :fri "freitags"
               :sat "samstags"
               :sun "sonntags"}
        td-style {:style {:padding-top "5px" :padding-bottom "5px"}}]
    [:div.col.s12 {:style {:margin-bottom "0.5rem"}}
     [:table {:style {:width "auto"}}
      [:tbody
       (doall (for [[key word] names
                    :let [short-name (name key)
                          {:keys [takes-place? times]} (key @(rf/subscribe [:get [:product :when :weekdays]]))]]
                ^{:key word}
                [:tr
                 [:td td-style (when (= key :mon) "Immer")]
                 [:td td-style (weekday key short-name takes-place? word)]
                 [:td td-style (when takes-place?
                                 (weekday-times key times))]]))]]]))

(rf/reg-event-db ::set-unit-duration
  (fn [db [_ unit-duration]]
    (-> db
        (assoc-in [:product :when :unit-duration] unit-duration)
        (assoc-in [:ui :unit-duration-set-manually?] (some? unit-duration))
        (assoc-in [:ui :last-focused-config-section] nil))))

(defn- duration []
  [:div>div.col.s12 {:style {:margin-bottom "0.5rem"}}
   "Ein Termin dauert "
   [widgets/inline-input
    {:value @(rf/subscribe [:get [:product :when :unit-duration]])
     :placeholder "z.B. 60 Minuten"
     :on-save #(rf/dispatch [::set-unit-duration %])
     :style {:width "10rem"}}]
   "."])

(defn- appointment-empty? [appointment]
  (every? str/blank? (map appointment [:date :time])))

(defn- mark-as-deleted-if-empty [appointment]
  (if (appointment-empty? appointment)
    (assoc appointment :deleted? true)
    appointment))

(defn- only-actual-appointments [appointments]
  (->> appointments
       (remove appointment-empty?)
       (remove :deleted?)))

(defn only-actual-schedules [schedules]
  (->> schedules
       (map #(update % :appointments only-actual-appointments))
       (filter #(-> % :appointments count (> 0)))
       (remove :deleted?)))

(rf/reg-sub ::num-appointments-usually
  :<- [:get [:product :how-much :number-of-appointments]]
  :<- [:get [:product :when :schedules]]

  (fn [[num-appointments schedules] _]
    (let [first-schedule (-> schedules only-actual-schedules first)
          num-appointments-in-first-schedule (-> first-schedule :appointments count)]
      (cond
        (not (str/blank? (str num-appointments))) num-appointments
        (> num-appointments-in-first-schedule 0) num-appointments-in-first-schedule))))

(defn- num-appointments-usually []
  (let [num-appointments-usually' @(rf/subscribe [::num-appointments-usually])]
    [:div.col.s12 {:style {:margin-bottom "0.5rem"}}
     "Ein Kurs umfasst normalerweise "
     [widgets/inline-input
      {:value num-appointments-usually'
       :on-save #(rf/dispatch [:set-path [:product :how-much :number-of-appointments] %])
       :style {:width "2rem"}}]
     (if (= 1 num-appointments-usually') " Termin." " Termine.")]))

(defn- init-vector [x]
  (if (vector? x) x []))

(defn- init-schedules [db]
  (update-in db [:product :when :schedules] init-vector))

(defn- init-appointments [db schedule-index]
  (update-in db [:product :when :schedules schedule-index :appointments] init-vector))

(defn- update-registration-deadline
  "Make the first date the registration deadline, if it wasn't edited manually yet."
  [schedule appointment-index]
  (let [first-appointment (datetime/string->date (get-in schedule [:appointments 0 :date]))]
    (if (and (= appointment-index 0)
             (str/blank? (:registration-deadline schedule))
             first-appointment)
      (assoc schedule :registration-deadline (datetime/format-date first-appointment))
      schedule)))

(defn- set-appointment-attribute [current-db schedule-index appointment-index key value]
  (-> current-db
      init-schedules
      (init-appointments schedule-index)
      (update-in [:product :when :schedules schedule-index :appointments]
                 (fn [appointments]
                   (let [new-appointment? (not (contains? appointments appointment-index))
                         other-key (case key :date :time :time :date)]
                     (if (and new-appointment? (nil? value))
                       appointments
                       (-> appointments
                           (assoc-in [appointment-index key] value)
                                        ; set date/time to empty string so that the field as validated,
                                        ; indicating to the user the requirement to fill it.
                           (update-in [appointment-index other-key] #(if (nil? %) "" %)))))))
      (update-in [:product :when :schedules schedule-index :appointments]
                 #(if (empty? %)
                    %
                    (into [(first %)] (mapv mark-as-deleted-if-empty (rest %)))))
      (update-in [:product :when :schedules schedule-index] update-registration-deadline appointment-index)
      reset-last-focused-config-section))

(rf/reg-event-db ::set-appointment-date
  (fn [db [_ schedule-index appointment-index new-date]]
    (-> db
        (set-appointment-attribute schedule-index appointment-index :date new-date))))

(rf/reg-event-db ::set-appointment-time
  (fn [db [_ schedule-index appointment-index new-time]]
    (-> db
        (set-appointment-attribute schedule-index appointment-index :time new-time))))

(rf/reg-sub ::product-when-schedules-n
  :<- [:get [:product :when :schedules]]

  (fn [product-when-schedules [_ n]]
    (get product-when-schedules n)))

(rf/reg-sub ::product-when-schedules-n-appointments
  (fn [[_ n]]
    [(rf/subscribe [::product-when-schedules-n n])])

  (fn [[product-when-schedules-n] _]
    (:appointments product-when-schedules-n)))

(rf/reg-sub ::first-appointment-index
  (fn [[_ n]]
    [(rf/subscribe [::product-when-schedules-n-appointments n])])

  (fn [[product-when-schedules-n-appointments] _]
    (->> product-when-schedules-n-appointments
         (take-while :deleted?)
         count)))

(rf/reg-sub ::first-appointment
  (fn [[_ index]]
    [(rf/subscribe [::product-when-schedules-n-appointments index])
     (rf/subscribe [::first-appointment-index index])])

  (fn [[product-when-schedules-n-appointments first-appointment-index] _]
    (get product-when-schedules-n-appointments first-appointment-index)))

(rf/reg-sub ::product-when-schedules-n-finished?
  (fn [[_ n]]
    [(rf/subscribe [::product-when-schedules-n n])])

  (fn [[product-when-schedules-n] _]
    (:finished? product-when-schedules-n)))

(defn- first-appointment-c [schedule-index]
  (let [finished? @(rf/subscribe [::product-when-schedules-n-finished? schedule-index])
        first-appointment-index @(rf/subscribe [::first-appointment-index schedule-index])
        {this-date :date
         this-time :time} @(rf/subscribe [::first-appointment schedule-index])
        past? (human/past? (datetime/string->date this-date))
        has-date? (-> this-date str/blank? not)
        has-time? (-> this-time str/blank? not)]
    [:div>div.col.s12 {:style {:margin-bottom "0.5rem"}}
     "Der erste Termin " (if past? "war" "ist") " am "
     [widgets/inline-date-input
      {:read-only? finished?
       :required? has-time?
       :value this-date
       :on-save #(rf/dispatch [::set-appointment-date schedule-index first-appointment-index %])}]
     " um "
     [widgets/inline-time-input
      {:read-only? finished?
       :required? has-date?
       :value this-time
       :on-save #(rf/dispatch [::set-appointment-time schedule-index first-appointment-index %])
       :style {:width "3rem"}}]
     "."]))

(rf/reg-event-db ::set-registration-deadline
  (fn [db [_ schedule-index new-deadline]]
    (-> db
        (update-in [:product :when :schedules] #(if (vector? %) % []))
        (assoc-in [:product :when :schedules schedule-index :registration-deadline] new-deadline)
        reset-last-focused-config-section)))

(rf/reg-sub ::product-when-schedules-n-registration-deadline
  (fn [[_ n]]
    [(rf/subscribe [::product-when-schedules-n n])])

  (fn [[product-when-schedules-n] _]
    (:registration-deadline product-when-schedules-n)))

(rf/reg-sub ::has-actual-appointments?
  (fn [[_ n]]
    [(rf/subscribe [::num-actual-appointments n])])

  (fn [[num-actual-appointments] _]
    (> num-actual-appointments 0)))

(defn- registration-deadline [schedule-index]
  (let [finished? @(rf/subscribe [::product-when-schedules-n-finished? schedule-index])
        date @(rf/subscribe [::product-when-schedules-n-registration-deadline schedule-index])
        past? (human/past? (datetime/string->date date))
        has-actual-appointments? @(rf/subscribe [::has-actual-appointments? schedule-index])]
    [:div>div.col.s12 {:style {:margin-bottom "0.5rem"}}
     "Anmeldungen " (if past? "waren" "sind") " zuletzt am "
     [widgets/inline-date-input
      {:read-only? finished?
       :required? has-actual-appointments?
       :value date
       :on-save #(rf/dispatch [::set-registration-deadline schedule-index %])}]
     " möglich."]))

(rf/reg-event-fx ::add-automatic-appointment
  (fn [{:keys [db]} [_ schedule-index]]
    (let [appointments (-> db :product :when :schedules (get schedule-index) :appointments)
          num-appointments (count appointments)
          prev-appointment (last appointments)]
      (merge
       {:db (if (some? prev-appointment)
              (let [new-appointment (-> prev-appointment
                                        (update :date
                                                #(-> %
                                                     datetime/string->date
                                                     (cljs-time.core/plus (weeks 1))
                                                     datetime/format-date))
                                        (dissoc :deleted?))]

                (-> db
                    (update-in [:product :when :schedules] #(if (vector? %) % []))
                    (assoc-in [:product :when :schedules schedule-index :appointments num-appointments] new-appointment)
                    save-scroll-position))
              db)}
       (when (some? prev-appointment)
         {:dispatch [::handlers/do-scroll-down]})))))

(rf/reg-sub ::appointment-numbers
  (fn [[_ n]]
    [(rf/subscribe [::product-when-schedules-n-appointments n])])

  (fn [[product-when-schedules-n-appointments] _]
    (as-> product-when-schedules-n-appointments x
          (map #(if (:deleted? %) 0 1) x)
          (conj x 1)
          (reductions + x))) ;; Number appointment consecutively, skipping deleted appointments. Deleted appointments have the
          ;; number of the next non-deleted appointment.
  )

(rf/reg-sub ::appointment
  (fn [[_ schedule-index _index]]
    [(rf/subscribe [::product-when-schedules-n-appointments schedule-index])])

  (fn [[product-when-schedules-n-appointments] [_ _schedule-index index]]
    (get product-when-schedules-n-appointments index)))

(rf/reg-sub ::appointment-date
  (fn [[_ schedule-index index]]
    [(rf/subscribe [::appointment schedule-index index])])

  (fn [[appointment] _]
    (:date appointment)))

(defn- appointment [schedule-index index number]
  (let [schedule-finished? @(rf/subscribe [::product-when-schedules-n-finished? schedule-index])
        {deleted? :deleted?
         this-time :time
         this-date :date
         :as current-appointment} @(rf/subscribe [::appointment schedule-index index])
        prev-appointment-date @(rf/subscribe [::appointment-date schedule-index (dec index)])]
    (if (nil? current-appointment)
      (let [next-date (some-> prev-appointment-date
                              datetime/string->date
                              (cljs-time.core/plus (weeks 1))
                              datetime/format-date)]
        [:div.appointment
         [:div.col.s2.right-align "weiterer Termin:"]
         [:div.col.s10
          ^{:key "add"}
          [:span
           [:button.btn {:on-click #(rf/dispatch [::add-automatic-appointment schedule-index])
                         :class (when (nil? next-date) "disabled")
                         :disabled (nil? next-date)}
            [:i.material-icons.left "add"] (or next-date "??.??.????")]
           " oder: am "]

          [widgets/inline-date-input
           {:read-only? schedule-finished?
            :value this-date
            :on-save #(rf/dispatch [::set-appointment-date schedule-index index %])}]]])

      (let [has-date? (-> this-date str/blank? not)
            has-time? (-> this-time str/blank? not)
            style (when deleted? {:text-decoration "line-through"})]
        [:div.appointment
         [:div.col.s2.right-align {:style style} (str number ". Termin:")]
         [:div.col.s10
          [widgets/inline-date-input
           {:read-only? schedule-finished?
            :required? has-time?
            :value this-date
            :style style
            :on-save #(rf/dispatch [::set-appointment-date schedule-index index %])}]
          [:span {:style style} " um "
           [widgets/inline-time-input
            {:read-only? schedule-finished?
             :required? has-date?
             :value this-time
             :style style
             :on-save #(rf/dispatch [::set-appointment-time schedule-index index %])}]]
          (when-not schedule-finished?
            [:span " "
             [:a.waves-effect {:style {:font-size "0.8rem"}
                               :on-click #(rf/dispatch [:toggle [:product :when :schedules schedule-index :appointments index :deleted?]])}
              (str "Termin " (if deleted? "wiederherstellen" "löschen"))]])]]))))

(rf/reg-sub ::num-appointments
  (fn [[_ n]]
    [(rf/subscribe [::product-when-schedules-n-appointments n])])

  (fn [[product-when-schedules-n-appointments] _]
    (count product-when-schedules-n-appointments)))

(rf/reg-sub ::num-actual-appointments
  (fn [[_ n]]
    [(rf/subscribe [::product-when-schedules-n-appointments n])])

  (fn [[product-when-schedules-n-appointments] _]
    (->> product-when-schedules-n-appointments
         (remove :deleted?)
         count)))

(defn- timetable [schedule-index]
  (let [num-appointments @(rf/subscribe [::num-appointments schedule-index])
        finished? @(rf/subscribe [::product-when-schedules-n-finished? schedule-index])
        appointment-numbers @(rf/subscribe [::appointment-numbers schedule-index])]
    [:div#timetable
     [:div.col.s12>h6 {:style {:margin-top "0.5rem"}}
      [:strong "Terminplan:"]]
     (let [last-index (if finished? num-appointments (inc num-appointments))]
       (doall (for [[index number] (map vector (range last-index) appointment-numbers)]
                ^{:key index}
                [appointment schedule-index index number])))]))

(rf/reg-sub ::schedule-open?
  (fn [[_ schedule-index]]
    [(rf/subscribe [::product-when-schedules-n schedule-index])])

  (fn [[schedule] _]
    (:open? schedule)))

(rf/reg-sub ::schedule-deleted?
  (fn [[_ schedule-index]]
    [(rf/subscribe [::product-when-schedules-n schedule-index])])

  (fn [[schedule] _]
    (:deleted? schedule)))

(rf/reg-sub ::schedule-schedule-id
  (fn [[_ schedule-index]]
    [(rf/subscribe [::product-when-schedules-n schedule-index])])

  (fn [[schedule] _]
    (:schedule-id schedule)))

(rf/reg-sub ::schedule-can-delete?
  (fn [[_ schedule-index]]
    [(rf/subscribe [::product-when-schedules-n schedule-index])])

  (fn [[schedule] _]
    (:can-delete? schedule)))

(rf/reg-sub ::schedule-num-internal-participants
  (fn [[_ schedule-index]]
    [(rf/subscribe [::product-when-schedules-n schedule-index])])

  (fn [[schedule] _]
    (:num-internal-participants schedule)))

(rf/reg-sub ::schedule-num-external-participants
  (fn [[_ schedule-index]]
    [(rf/subscribe [::product-when-schedules-n schedule-index])])

  (fn [[schedule] _]
    (:num-external-participants schedule)))

(defn- schedule [schedule-index]
  (let [path [:product :when :schedules schedule-index]
        company-area-product? @(rf/subscribe [:get [:product :company-area?]])
        current-duration @(rf/subscribe [:get [:product :when :unit-duration]])
        open? @(rf/subscribe [::schedule-open? schedule-index])
        deleted? @(rf/subscribe [::schedule-deleted? schedule-index])
        schedule-id @(rf/subscribe [::schedule-schedule-id schedule-index])
        can-delete? @(rf/subscribe [::schedule-can-delete? schedule-index])
        num-internal-participants @(rf/subscribe [::schedule-num-internal-participants schedule-index])
        num-external-participants @(rf/subscribe [::schedule-num-external-participants schedule-index])
        num-appointments @(rf/subscribe [::num-actual-appointments schedule-index])
        first-appointment-value @(rf/subscribe [::appointment schedule-index 0])
        new? (nil? schedule-id)
        num-internal (or num-internal-participants 0)
        num-external (or num-external-participants 0)
        num-participants (+ num-internal num-external)
        has-participants? (pos? num-participants)]
    [:div.row
     [:div.col.s6
      (let [title (str (:date first-appointment-value)
                       (some->> first-appointment-value :time (str " um ")))
            info (when (> num-appointments 0)
                   (str " ("
                        (when-not new? (str (case num-participants
                                              0 "keine Anmeldungen"
                                              1 "eine Anmeldung"
                                              (str num-participants " Anmeldungen, "
                                                   (if (= num-external 0)
                                                     "alle"
                                                     (str "davon " (if (= 0 num-internal) "keine" num-internal)))
                                                   " über Machtfit"))
                                            "; "))
                        num-appointments (if (not (str/blank? current-duration))
                                           (str " × " current-duration)
                                           (if (= 1 num-appointments) " Termin" " Termine"))
                        ")"))]
        [:span (when deleted? {:style {:text-decoration "line-through"}})
         [:strong (if (str/blank? title) "neuer Kurs" title)]
         info])]

     (when-not deleted? [:div.col.s2
                         [:a.waves-effect
                          {:on-click #(rf/dispatch [:toggle (conj path :open?)])}
                          [:i.material-icons.tiny (if open? "expand_less" "expand_more")]
                          (if open? "Zuklappen" "Aufklappen")]])

     [:div.col.s4 {:style {:margin-bottom "0.5rem"}
                   :class (when deleted? "offset-s2")}
      [:button.waves-effect.btn.btn-flat
       (into {:style {:margin-left "0.5rem"
                      :padding "0 0.8rem"
                      :background (when (and company-area-product?
                                             has-participants?
                                             (not deleted?))
                                    "red")}}
             (if (or can-delete? company-area-product?)
               {:on-click #(rf/dispatch [:toggle (conj path :deleted?)])}
               {:class "disabled"}))

       [:i.material-icons.left (if deleted? "settings_backup_restore" "delete")]
       (cond
         deleted? "Wiederherstellen"
         has-participants? "Löschen mit Teilnehmern"
         :else "Löschen")]]

     (when (and open? (not deleted?))
       [:div.col.offset-s1.s11
        (when (> num-participants 0)
          [:div.col.s12 {:style {:margin-bottom "0.5rem" :font-style "italic"}}
           "Falls Sie Terminänderungen vornehmen, denken Sie bitte daran, die angemeldeten Teilnehmer zu informieren."])
        ^{:key "first-appointment"} [first-appointment-c schedule-index]
        ^{:key "registration-deadline"} [registration-deadline schedule-index]
        ^{:key "timetable"} [timetable schedule-index]])]))

(rf/reg-sub ::num-schedules
  :<- [:get [:product :when :schedules]]

  (fn [product-when-schedules _]
    (->> product-when-schedules (remove :deleted?) count)))

(rf/reg-sub ::current-schedules
  :<- [:get [:product :when :schedules]]

  (fn [product-when-schedules _]
    (let [finished? #(= true (:finished? %))]
      (->> product-when-schedules
           (map-indexed vector)
           (remove #(finished? (second %)))
           (map first)))))

(rf/reg-sub ::finished-schedules
  :<- [:get [:product :when :schedules]]

  (fn [product-when-schedules _]
    (let [finished? #(= true (:finished? %))]
      (->> product-when-schedules
           (map-indexed vector)
           (filter #(finished? (second %)))
           (map first)))))

(rf/reg-event-fx ::add-schedule
  (fn [{:keys [db]} _]
    (let [path [:product :when :schedules]
          new-schedule {:open? true
                        :can-delete? true}]
      {:dispatch [::handlers/do-scroll-down]
       :db (-> db
               (update-in path #(conj (or % []) new-schedule))
               save-scroll-position)})))

(defn- add-schedule-button []
  ^{:key "add-schedule-button"}
  [:div.col.s12 {:style {:margin-bottom "1rem" :margin-top "1rem"}}
   [:button.waves-effect.waves-light.btn
    {:on-click #(rf/dispatch [::add-schedule])}
    [:i.material-icons.left "add"] "Kurs hinzufügen"]])

(defn- cohesion-progressive []
  (let [current-schedules @(rf/subscribe [::current-schedules])
        finished-schedules @(rf/subscribe [::finished-schedules])
        has-current-schedules? (-> current-schedules empty? not)
        has-finished-schedules? (-> finished-schedules empty? not)]
    [:div
     (list
      ^{:key "kursplan"} [:div.col.s12
                          ^{:key "h5"}
                          [:h5 {:style {:margin-top "1rem"}}
                           (if has-finished-schedules?
                             "Aktuelle Kurse:"
                             "Kursplan:")]]
      (when has-current-schedules?
        (for [schedule-index current-schedules]
          ^{:key (str "schedule-" schedule-index)}
          [schedule schedule-index]))
      ^{:key "add-schedule"} [add-schedule-button]

      (when has-finished-schedules?
        ^{:key "kursplan-finished"} [:div>div.col.s12>h5 "Beendete Kurse:"])
      (when has-finished-schedules?
        (for [schedule-index finished-schedules]
          ^{:key (str "schedule-finished-" schedule-index)}
          [schedule schedule-index]))

      ^{:key "duration"} [duration]
      ^{:key "num-appointments-usually"} [num-appointments-usually])]))

(rf/reg-sub ::num-slots
  :<- [:get [:product :when :slots]]

  (fn [product-when-slots _]
    (->> product-when-slots (remove :deleted?) count)))

(rf/reg-event-db ::set-slot-group-date
  (fn [db [_ slot-group date]]
    (-> db
        (update-in [:product :when :slots] (fn [slots]
                                             (mapv #(if (= (:group %) slot-group)
                                                      (assoc % :date date)
                                                      %) slots))))))

(defn- slot->datetime [slot]
  (let [last-slot-date (datetime/string->date (:date slot))
        last-slot-time (human/human->time (:time slot))]
    (when (and (some? last-slot-date) (some? last-slot-time))
      (local-date-time (year last-slot-date)
                       (month last-slot-date)
                       (day last-slot-date)
                       (:hour last-slot-time)
                       (:minute last-slot-time)))))

(defn- ms->mins [ms]
  (/ ms 1000 60))

(defn- auto-fill-time-slot-duration [current-db]
  (let [first-slot (get-in current-db [:product :when :slots 0])
        second-slot (get-in current-db [:product :when :slots 1])
        first-slot-datetime (slot->datetime first-slot)
        second-slot-datetime (slot->datetime second-slot)]
    (if (and (not (-> current-db :ui :unit-duration-set-manually?))
             (some? first-slot-datetime)
             (some? second-slot-datetime))
      (let [diff-in-minutes (ms->mins (- second-slot-datetime first-slot-datetime))
            auto-duration (str diff-in-minutes " Minuten")]
        (assoc-in current-db [:product :when :unit-duration] auto-duration))
      current-db)))

(rf/reg-event-db ::set-slot-time
  (fn [db [_ slot-index time]]
    (-> db
        (assoc-in [:product :when :slots slot-index :time] time)
        auto-fill-time-slot-duration)))

(defn- vec-remove [coll pos]
  (vec (concat (subvec coll 0 pos) (subvec coll (inc pos)))))

(rf/reg-event-db ::delete-slot
  (fn [db [_ slot-index]]
    (-> db
        (update-in [:product :when :slots] vec-remove slot-index)
        auto-fill-time-slot-duration)))

(rf/reg-event-db ::toggle-delete-company-slot-with-participants
  (fn [db [_ slot-index]]
    (update-in db [:product :when :slots slot-index :delete-with-participants?] not)))

(rf/reg-sub ::slot
  :<- [:get [:product :when :slots]]
  :<- [:get [:product :company-area?]]

  (fn [[slots company-area?] [_ slot-index]]
    (let [{:keys [can-delete?] :as slot} (get slots slot-index)]
      (cond-> slot
        company-area? (assoc :has-participants? (not can-delete?))))))

(defn- slot-time [slot-index]
  (let [{slot-time' :time
         slot-date' :date
         slot-can-delete? :can-delete?
         company-slot-has-participants? :has-participants?
         delete-company-slot-with-participants? :delete-with-participants?} @(rf/subscribe [::slot slot-index])
        has-date? (-> slot-date' str/blank? not)]
    [:td {:style
          (merge
           @(rf/subscribe [::review/style-for-field [:when :slots (keyword (str slot-index))]])
           {:padding "0"})}
     " um " [widgets/inline-time-input
             {:value slot-time'
              :required? has-date?
              :validate-virgin? has-date?
              :on-save #(rf/dispatch [::set-slot-time slot-index %])}]
     [:a {:class "waves-effect"
          :style {:font-size "0.8rem"
                  :color (cond
                           delete-company-slot-with-participants? "green"

                           company-slot-has-participants? "red"

                           (not slot-can-delete?) "grey"

                           :else nil)}
          :on-click #(cond
                       company-slot-has-participants?
                       (rf/dispatch [::toggle-delete-company-slot-with-participants slot-index])

                       slot-can-delete?
                       (rf/dispatch [::delete-slot slot-index])

                       :else nil)}
      (cond
        delete-company-slot-with-participants?
        "Termin mit den Teilnehmern wiederherstellen"

        company-slot-has-participants?
        "Termin mit Teilnehmern löschen"

        :else "Termin löschen")]]))

(defn- slot-date [slot-index]
  (let [{this-date :date
         this-time :time
         slot-group :group} @(rf/subscribe [::slot slot-index])
        has-time? (-> this-time str/blank? not)]
    [:td {:style {:padding "0.2rem 0"}}
     " am " [widgets/inline-date-input
             {:value this-date
              :required? has-time?
              :validate-virgin? has-time?
              :on-save #(rf/dispatch [::set-slot-group-date slot-group %])}]]))

(defn- second-to-last [coll]
  (let [n (count coll)]
    (when (> n 1)
      (nth coll (- n 2)))))

(defn- insert-at [v pos item]
  (vec (concat (subvec v 0 pos) [item] (subvec v pos))))

(defn- slot-indices-in-group [group slots]
  (->> slots
       (map-indexed #(assoc %2 :index %1))
       (filter #(= group (:group %)))
       (mapv :index)))

(rf/reg-sub ::slot-indices-in-group
  :<- [:get [:product :when :slots]]

  (fn [slots [_ group]]
    (slot-indices-in-group group slots)))

(defn- slot-complete? [slot]
  (let [slot-time' (:time slot)
        slot-date' (:date slot)
        time-complete? (some? (human/human->time slot-time'))
        date-complete? (some? (datetime/string->date slot-date'))]
    (and time-complete? date-complete?)))

(rf/reg-event-fx ::add-slot-time
  (fn [{:keys [db]} [_ slot-group]]
    {:dispatch [::handlers/do-scroll-down]
     :db (let [slots (-> db :product :when :slots)]
           (-> db
               (update-in [:product :when :slots]
                          #(let [group-indices (slot-indices-in-group slot-group slots)
                                 last-group-index (last group-indices)
                                 last-slot (get % last-group-index)
                                 last-slot-complete? (slot-complete? last-slot)]
                             (if last-slot-complete?
                               (let [last-slot-datetime (slot->datetime last-slot)
                                     second-to-last-slot (get % (second-to-last group-indices))
                                     time-offset (if (nil? second-to-last-slot)
                                                   20
                                                   (ms->mins (- last-slot-datetime (slot->datetime second-to-last-slot))))
                                     new-slot-time (cljs-time.core/plus last-slot-datetime (minutes time-offset))
                                     new-slot (-> last-slot
                                                  (merge {:time (human/timeformat {:hour (hour new-slot-time)
                                                                                   :minute (minute new-slot-time)})
                                                          :can-delete? true})
                                                  (dissoc :slot-id))]
                                 (insert-at % (inc last-group-index) new-slot))
                               %)))
               auto-fill-time-slot-duration
               save-scroll-position))}))

(defn- slot-add-time [slot-group]
  [:tr
   [:td {:style {:padding "0.2rem 0"}}]
   [:td {:style {:padding "0.2rem 0"}}
    [:a.waves-effect {:style {:font-size "0.8rem"}
                      :on-click (comp #(rf/dispatch [::add-slot-time slot-group]) machtfit/stop-event)
                      :href "#"}
     "Termin hinzufügen"]]])

(defn- slot-group [group]
  (let [slot-indices-in-group' @(rf/subscribe [::slot-indices-in-group group])
        first-slot-index (first slot-indices-in-group')]
    [:<>
     ^{:key (str "slot-" first-slot-index)}
     [:tr
      [slot-date first-slot-index]
      [slot-time first-slot-index]]

     (for [slot-index (rest slot-indices-in-group')]
       ^{:key (str "slot-" slot-index)}
       [:tr
        [:td {:style {:padding "0.2rem 0"}} " "]
        [slot-time slot-index]])
     [slot-add-time group]]))

(rf/reg-sub ::slot-groups
  :<- [:get [:product :when :slots]]

  (fn [slots _]
    (->> slots (map :group) (apply sorted-set))))

(rf/reg-event-fx ::add-slots-day
  (fn [{:keys [db]} _]
    {:dispatch [::handlers/do-scroll-down]
     :db (-> db
             (update-in [:product :when :slots]
                        (fn [slots]
                          (let [last-slot (last slots)
                                last-day (:date last-slot)
                                last-date (datetime/string->date last-day)
                                next-group (inc (:group last-slot))
                                next-day (if (some? last-date)
                                           (-> last-date
                                               (cljs-time.core/plus (days 1))
                                               datetime/format-date)
                                           "")
                                times (if (some? last-date)
                                        (->> slots
                                             (filter #(= last-day (:date %)))
                                             (map :time))
                                        [(:time last-slot)])
                                time->new-slot #(hash-map :date next-day :can-delete? true :time % :group next-group)]
                            (into slots (map time->new-slot times)))))
             save-scroll-position)}))

(defn- slot-add-day []
  [:tr
   [:td {:style {:padding "0.2rem 0"}}
    [:button.waves-effect.waves-light.btn
     {:on-click #(rf/dispatch [::add-slots-day])}
     [:i.material-icons.left "add"] "Tag hinzufügen"]]])

(defn- slots []
  [:div
   [:div.col.s12 {:style {:margin-bottom "1rem"}}
    [:h5 {:style {:margin-top "1rem"}}
     [review/highlighted-field-span [:when :slots] "Termine:"]]
    [:table {:style {:width "auto"}}
     [:tbody
      (for [this-slot-group @(rf/subscribe [::slot-groups])]
        ^{:key (str "slot-group-" this-slot-group)}
        [slot-group this-slot-group])
      ^{:key "slot-group-add"}
      [slot-add-day]]]]])

(rf/reg-event-db ::set-registration-deadline-relative-value
  (fn [db [_ new-value]]
    (-> db
        (assoc-in [:product :when :registration-deadline-relative]
                  (let [v (int new-value)]
                    {:choice (if (>= v 1) :set :unset) :value v}))
        (assoc-in [:ui :last-focused-config-section] :when))))

(rf/reg-event-db ::set-registration-deadline-relative-choice
  (fn [db [_ new-choice]]
    (-> db
        (update-in [:product :when :registration-deadline-relative]
                   #(let [current-value (:value %)
                          default-value 5]
                      (if (= :set new-choice)
                        {:choice :set
                         :value (cond
                                  (nil? current-value) default-value
                                  (>= current-value 1) current-value
                                  :else default-value)}
                        {:choice :unset
                         :value current-value})))
        (assoc-in [:ui :last-focused-config-section] :when))))

(defn- registration-deadline-relative []
  (let [{:keys [choice value]} @(rf/subscribe [:get [:product :when :registration-deadline-relative]])
        singular? (= 1 value)]
    [:div.col.s12 {:style {:margin "0.5rem 0"}}
     [widgets/choice-left-justified
      {:name "registration-deadline-relative"
       :intro "Anmeldungen sind"
       :choices [[:unset "noch am Tag des jeweiligen Termins"]
                 [:set [:span "bis "
                        [widgets/inline-input
                         {:value (case choice :set value "")
                          :on-save #(rf/dispatch [::set-registration-deadline-relative-value %])
                          :style {:width "2rem"}}]
                        (str (if singular? "Tag" "Tage") " vor dem Termin")]]]
       :current-choice choice
       :on-select #(rf/dispatch [::set-registration-deadline-relative-choice %])
       :outro "möglich."}]]))

(defn section-when []
  (let [has-schedule? @(rf/subscribe [:get [:product :when :has-schedule?]])
        current-sessions-per-signup @(rf/subscribe [:get [:product :when :sessions-per-signup]])
        multiple-sessions? (= current-sessions-per-signup :multiple-sessions)
        config-active? @(rf/subscribe [::section/section-configuration-active? :when])
        current-cohesion @(rf/subscribe [:get [:product :when :cohesion]])
        partner-product? @(rf/subscribe [:get [:options :partner-product?]])
        editable? @(rf/subscribe [::product-form/meta-editable?])]
    [widgets/section {:anchor "when"
                      :title [review/highlighted-section-title :when "Wann"]
                      :subtitle [:div "findet das Angebot statt?"
                                 [review/field-badges :when]]
                      :content (let [divider ^{:key "divider"}
                                     [:div.clearfix.divider {:style {:margin-bottom "0.75rem"
                                                                     :margin-left "0.75rem"}}]]
                                 (-> ^{:key "when-section"} [:div]
                                     (into (if (and editable? config-active?)
                                             [^{:key "has-schedule"}
                                              [:div
                                               [has-schedule]]
                                              ^{:key "sessions-per-signup"}
                                              [:div
                                               (when has-schedule? [sessions-per-signup])]
                                              ^{:key "volatility"}
                                              [:div
                                               (when (and has-schedule? multiple-sessions?)
                                                 [cohesion])]]

                                             [^{:key "change"}
                                              [:div
                                               [:div.col.s10>p
                                                [has-schedule-ro]
                                                " "
                                                (when has-schedule? [sessions-per-signup-ro])
                                                " "
                                                (when (and has-schedule? multiple-sessions?) [cohesion-ro])]
                                               (when editable?
                                                 [:div.col.s2>p>a.btn {:on-click #(rf/dispatch [::section/focus-config-section :when])}
                                                  "Ändern"])]]))

                                     (into (when has-schedule?
                                             (match [current-sessions-per-signup current-cohesion]
                                               [:multiple-sessions :independent] [divider
                                                                                  ^{:key "weekdays"} [weekdays]
                                                                                  ^{:key "duration"} [duration]]
                                               [:multiple-sessions :progressive] [divider
                                                                                  ^{:key "cohesion-progressive"}
                                                                                  [cohesion-progressive]]
                                               [:one-session _] [divider
                                                                 ^{:key "slots"}
                                                                 [slots]
                                                                 ^{:key "duration"}
                                                                 [duration]
                                                                 ^{:key "registration-deadline"}
                                                                 [registration-deadline-relative]]
                                               :else nil)))
                                     (into (when (and has-schedule?
                                                      (not partner-product?))
                                             [[offer-list-deadline]]))
                                     (into (when (or (= false has-schedule?)
                                                     (= :one-session current-sessions-per-signup)
                                                     (some? current-cohesion))
                                             [^{:key "show-next-section"}
                                              [show-next-section :when]]))))}]))
